import { render } from "./PuzzleIcon.vue?vue&type=template&id=5339512e"
import script from "./PuzzleIcon.vue?vue&type=script&lang=js"
export * from "./PuzzleIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__